export enum InputDevice {
    Keyboard = 'keyboard',
    Mouse = 'mouse',
    Wheel = 'wheel'
}
